import { useAtomValue, useSetAtom } from 'jotai';

import { panelsAtom, closePanelAtom, PanelId } from '@/stores/panels';
import { useResponsivePanel } from '@/hooks/useResponsivePanel';
import { FloatingPanel } from './FloatingPanel';
import { MobileModal } from './MobileModal';

interface ResponsivePanelWrapperProps {
  panelId: PanelId;
  title: string;
  children: React.ReactNode;
}

export function ResponsivePanelWrapper({ panelId, title, children }: ResponsivePanelWrapperProps) {
  const { isMobile } = useResponsivePanel();
  const panel = useAtomValue(panelsAtom)[panelId];
  const closePanel = useSetAtom(closePanelAtom);

  if (isMobile) {
    return (
      <MobileModal isOpen={panel.isOpen} title={title} onClose={() => closePanel(panelId)}>
        {children}
      </MobileModal>
    );
  }

  return (
    <FloatingPanel panelId={panelId} title={title} onClose={() => closePanel(panelId)}>
      {children}
    </FloatingPanel>
  );
}

export default ResponsivePanelWrapper;
